var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "clini-nutrit" }, [
    _c(
      "div",
      { staticClass: "nutrit-content padding-main mobile-padding" },
      [
        _c(
          "el-row",
          [
            _c(
              "el-col",
              { staticClass: "nutrit-desc", attrs: { xs: 24, sm: 24, md: 9 } },
              [
                _c("div", { staticClass: "nutrit-title" }, [
                  _vm._v(_vm._s(_vm.$t("cliniNutrit.cliniNutritMana"))),
                ]),
                _c("div", { staticClass: "nutrit-tip" }, [
                  _vm._v(_vm._s(_vm.$t("cliniNutrit.cliniNutritManaTip"))),
                ]),
                _c(
                  "el-button",
                  {
                    staticClass: "hidden-sm-and-down",
                    attrs: { size: "medium", round: "", type: "primary" },
                    on: { click: _vm.jumpPage },
                  },
                  [
                    _vm._v(_vm._s(_vm.$t("home.cliniNutritSystem"))),
                    _c("i", { staticClass: "el-icon-arrow-right" }),
                  ]
                ),
              ],
              1
            ),
            _c(
              "el-col",
              {
                staticStyle: { "text-align": "right" },
                attrs: { xs: 24, sm: 24, md: 15 },
              },
              [
                _c(
                  "div",
                  { staticClass: "image-flex" },
                  [
                    _c("el-image", {
                      staticClass: "hidden-sm-and-down",
                      attrs: { fit: "cover", src: "/img/home-new_02.png" },
                    }),
                    _c("el-image", {
                      staticClass: "hidden-md-and-up",
                      attrs: { fit: "cover", src: "/img/home-new_mobile.png" },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "system-features mobile-padding" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(
          "\n      " + _vm._s(_vm.$t("cliniNutrit.systemFeatures")) + "\n    "
        ),
      ]),
      _c("div", { staticClass: "mid-box hidden-sm-and-down" }, [
        _vm._m(0),
        _c("div", { staticClass: "left-top tip-box" }, [
          _c("img", { attrs: { src: "/img/left-top-icon.png" } }),
          _c("div", { staticClass: "tip-title" }, [
            _vm._v(_vm._s(_vm.$t("cliniNutrit.seamlessDocking"))),
          ]),
          _c("div", { staticClass: "tip" }, [
            _vm._v(_vm._s(_vm.$t("cliniNutrit.seamlessDockingTip"))),
          ]),
        ]),
        _c("div", { staticClass: "left-mid tip-box" }, [
          _c("img", { attrs: { src: "/img/left-bottom-icon.png" } }),
          _c("div", { staticClass: "tip-title" }, [
            _vm._v(_vm._s(_vm.$t("cliniNutrit.easyUse"))),
          ]),
          _c("div", { staticClass: "tip" }, [
            _vm._v(_vm._s(_vm.$t("cliniNutrit.easyUseTip"))),
          ]),
        ]),
        _c("div", { staticClass: "left-bottom tip-box" }, [
          _c("img", { attrs: { src: "/img/right-mid-icon.png" } }),
          _c("div", { staticClass: "tip-title" }, [
            _vm._v(_vm._s(_vm.$t("cliniNutrit.supplyChainSystem"))),
          ]),
          _c("div", { staticClass: "tip" }, [
            _vm._v(_vm._s(_vm.$t("cliniNutrit.supplyChainSystemTip"))),
          ]),
        ]),
        _c("div", { staticClass: "right-top tip-box" }, [
          _c("img", { attrs: { src: "/img/left-mid-icon.png" } }),
          _c("div", { staticClass: "tip-title" }, [
            _vm._v(_vm._s(_vm.$t("cliniNutrit.treatmentProcedures"))),
          ]),
          _c("div", { staticClass: "tip" }, [
            _vm._v(_vm._s(_vm.$t("cliniNutrit.treatmentProceduresTip"))),
          ]),
        ]),
        _c("div", { staticClass: "right-mid tip-box" }, [
          _c("img", { attrs: { src: "/img/right-top-icon.png" } }),
          _c("div", { staticClass: "tip-title" }, [
            _vm._v(_vm._s(_vm.$t("cliniNutrit.professionalMana"))),
          ]),
          _c("div", { staticClass: "tip" }, [
            _vm._v(_vm._s(_vm.$t("cliniNutrit.professionalManaTip"))),
          ]),
        ]),
        _c("div", { staticClass: "right-bottom tip-box" }, [
          _c("img", { attrs: { src: "/img/right-bottom-icon.png" } }),
          _c("div", { staticClass: "tip-title" }, [
            _vm._v(_vm._s(_vm.$t("cliniNutrit.hospitalMana"))),
          ]),
          _c("div", { staticClass: "tip" }, [
            _vm._v(_vm._s(_vm.$t("cliniNutrit.hospitalManaTip"))),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "mid-box-mobile hidden-md-and-up" }, [
        _c(
          "div",
          { staticClass: "left-top tip-box" },
          [
            _c("el-image", {
              attrs: { fit: "cover", src: "/img/left-top-icon.png" },
            }),
            _c("div", { staticClass: "mid-right" }, [
              _c("div", { staticClass: "tip-title" }, [
                _vm._v(_vm._s(_vm.$t("cliniNutrit.seamlessDocking"))),
              ]),
              _c("div", { staticClass: "tip" }, [
                _vm._v(_vm._s(_vm.$t("cliniNutrit.seamlessDockingTip"))),
              ]),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "left-mid tip-box" },
          [
            _c("el-image", {
              attrs: { fit: "cover", src: "/img/left-mid-icon.png" },
            }),
            _c("div", { staticClass: "mid-right" }, [
              _c("div", { staticClass: "tip-title" }, [
                _vm._v(_vm._s(_vm.$t("cliniNutrit.treatmentProcedures"))),
              ]),
              _c("div", { staticClass: "tip" }, [
                _vm._v(_vm._s(_vm.$t("cliniNutrit.treatmentProceduresTip"))),
              ]),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "left-bottom tip-box" },
          [
            _c("el-image", {
              attrs: { fit: "cover", src: "/img/left-bottom-icon.png" },
            }),
            _c("div", { staticClass: "mid-right" }, [
              _c("div", { staticClass: "tip-title" }, [
                _vm._v(_vm._s(_vm.$t("cliniNutrit.easyUse"))),
              ]),
              _c("div", { staticClass: "tip" }, [
                _vm._v(_vm._s(_vm.$t("cliniNutrit.easyUseTip"))),
              ]),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "right-top tip-box" },
          [
            _c("el-image", {
              attrs: { fit: "cover", src: "/img/right-top-icon.png" },
            }),
            _c("div", { staticClass: "mid-right" }, [
              _c("div", { staticClass: "tip-title" }, [
                _vm._v(_vm._s(_vm.$t("cliniNutrit.professionalMana"))),
              ]),
              _c("div", { staticClass: "tip" }, [
                _vm._v(_vm._s(_vm.$t("cliniNutrit.professionalManaTip"))),
              ]),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "right-mid tip-box" },
          [
            _c("el-image", {
              attrs: { fit: "cover", src: "/img/right-mid-icon.png" },
            }),
            _c("div", { staticClass: "mid-right" }, [
              _c("div", { staticClass: "tip-title" }, [
                _vm._v(_vm._s(_vm.$t("cliniNutrit.supplyChainSystem"))),
              ]),
              _c("div", { staticClass: "tip" }, [
                _vm._v(_vm._s(_vm.$t("cliniNutrit.supplyChainSystemTip"))),
              ]),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "right-bottom tip-box" },
          [
            _c("el-image", {
              attrs: { fit: "cover", src: "/img/right-bottom-icon.png" },
            }),
            _c("div", { staticClass: "mid-right" }, [
              _c("div", { staticClass: "tip-title" }, [
                _vm._v(_vm._s(_vm.$t("cliniNutrit.hospitalMana"))),
              ]),
              _c("div", { staticClass: "tip" }, [
                _vm._v(_vm._s(_vm.$t("cliniNutrit.hospitalManaTip"))),
              ]),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "mid-center" },
          [
            _c("el-image", {
              attrs: { fit: "cover", src: "/img/mid-center-mobile.png" },
            }),
          ],
          1
        ),
      ]),
    ]),
    _c("div", { staticClass: "main-function padding-main mobile-padding" }, [
      _c("div", { staticClass: "list-name" }, [
        _vm._v(
          "\n      " + _vm._s(_vm.$t("cliniNutrit.mainFunction")) + "\n    "
        ),
      ]),
      _c(
        "div",
        { staticClass: "list" },
        _vm._l(_vm.funcList, function (item, index) {
          return _c(
            "div",
            { key: index, staticClass: "list-item" },
            [
              _c("el-image", {
                attrs: {
                  src: _vm.vaildatePc() ? item.icon : item.mobile_icon,
                  fit: "cover",
                },
              }),
              _c("div", { staticClass: "item-title" }, [
                _vm._v(_vm._s(item.title)),
              ]),
              _c("div", { staticClass: "item-desc" }, [
                _vm._v(_vm._s(item.desc)),
              ]),
            ],
            1
          )
        }),
        0
      ),
    ]),
    _c("div", { staticClass: "mobile-bottom" }),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mid-center" }, [
      _c("img", { attrs: { src: "/img/mid-center.png" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }